<template>
  <div class="about">
    <div class="pc-box">
      <PCAbout v-bind="$attrs" />
    </div>
    <div class="mb-box">
      <MBAbout />
    </div>
  </div>
</template>

<script>

import PCAbout from "@/views/PCAbout.vue"
import MBAbout from "@/views/MBAbout.vue"

export default {
  name:"About",
  data(){
    return {
      PCandMB:false
    }
  },

  components:{
    PCAbout,
    MBAbout
  },
  methods:{
    listenerWidth(){
      if(window.innerWidth<769){
        this.PCandMB=false
      }else{
        this.PCandMB=true
      }
    }
  }
}
</script>

<style scoped lang="less">
.about{
  height: 100vh;
}
@media screen and (max-width: 769px) {
  .pc-box{
    display: none;
  }
}
@media screen and (min-width: 769px) {
  .mb-box{
    display: none;
  }
}
</style>
